import React from 'react';
import {SFC} from 'types/generic';
import * as S from './Style';

const Shadow: SFC = ({className}) => <S.Shadow className={className} />;

export default Shadow;
